// extracted by mini-css-extract-plugin
export default {"notification":"ucxyfUbd","message":"wglJ1HwW","content":"anl10d25","icon":"Ff5U0DFS","info":"ZvjE7uSl","success":"eYxQ5m_9","warning":"YI9P6rAW","error":"L2DwMiWj"};